module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-2@3x.ver2_0_2.jpg?3eb58770";